import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export const HomeNav = ({ onPartner, dark = false }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const linkCls = dark ? 'text-white/85 hover:text-white' : 'text-[#3E4C43] hover:text-[#1A3626]';
  const links = [
    { label: 'Find Venues', to: '/' },
    { label: 'Browse All Venues', to: '/venues' },
    { label: 'How WVC Works', to: '/#how-it-works' },
    { label: 'For Venue Owners', to: '/#for-venue-owners' },
    { label: 'Venue Intelligence', to: '/intelligence' },
  ];
  return (
    <nav className={`absolute top-0 left-0 right-0 z-40 font-wvc-body ${dark ? '' : 'border-b border-[#1A3626]/10'}`} data-testid="home-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between">
        <Link to="/" className="flex flex-col leading-none" data-testid="nav-logo">
          <span className={`font-wvc-display text-3xl md:text-4xl font-bold tracking-tight ${dark ? 'text-white' : 'text-[#1A201C]'}`}>
            WVC<span className="text-[#C6A87C]">.</span>
          </span>
          <span className={`text-[9px] md:text-[10px] uppercase tracking-[0.28em] mt-1 ${dark ? 'text-[#E5D8C6]' : 'text-[#748278]'}`}>A Happy Retreats Company</span>
        </Link>
        <div className="hidden lg:flex items-center gap-7 text-sm">
          {links.map(l => (
            <Link key={l.label} to={l.to} className={`${linkCls} transition-colors`} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, '-')}`}>{l.label}</Link>
          ))}
          <button onClick={onPartner} className={`${linkCls} transition-colors text-sm`} data-testid="nav-list-your-venue">List Your Venue</button>
          <button
            onClick={() => navigate('/venues')}
            className="bg-[#1A3626] text-white hover:bg-[#254834] rounded-full px-6 py-2.5 text-sm transition-all duration-300"
            data-testid="nav-check-availability"
          >
            Check Venue Availability
          </button>
        </div>
        <button className={`lg:hidden ${dark ? 'text-white' : 'text-[#1A201C]'}`} onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-white border-b border-[#1A3626]/10 px-6 py-4 space-y-3 shadow-lg" data-testid="nav-mobile-menu">
          {links.map(l => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="block text-[#1A201C] py-1.5">{l.label}</Link>
          ))}
          <button onClick={() => { setOpen(false); onPartner(); }} className="block text-[#1A201C] py-1.5">List Your Venue</button>
          <button onClick={() => { setOpen(false); navigate('/venues'); }} className="w-full bg-[#1A3626] text-white rounded-full px-6 py-3 mt-2">Check Venue Availability</button>
        </div>
      )}
    </nav>
  );
};
